/* global define APP_CONFIG */
import React from 'react';
import { Router, browserHistory, withRouter } from 'react-router/es';
import { routeCodes, subRouteCodes } from 'constants/routes';
import App from 'containers/App';
import Dashboard from 'containers/Dashboard';

const googleAnalyticsCode = APP_CONFIG.googleAnalytics;

function logPageView() {
  if (googleAnalyticsCode) {

    gtag('config', googleAnalyticsCode, {
      send_page_view: false
    });

    gtag('event', 'page_view', {
      page_title: document.title,
      page_location: window.location.pathname,
      page_path: window.location.pathname,
      send_to: googleAnalyticsCode
    })

  }
  window.scrollTo(0, 0);
}

const componentRoutes = {
  component: App,
  path: routeCodes.INDEX,
  indexRoute: { component: Dashboard },
  childRoutes: [
    {
      path: routeCodes.DASHBOARD,
      getComponent(location, cb) {
        import('./containers/Dashboard')
        .then((module) => {
          cb(null, withRouter(module.default));
        });
      },
    },
    {
      path: `${ routeCodes.ONBOARDING }(/:workflow)`,
      getComponent(location, cb) {
        import('./containers/Onboarding')
        .then((module) => {
          cb(null, withRouter(module.default));
        });
      },
    },
    {
      path: routeCodes.MENU_ENGINEERING,
      getComponent(location, cb) {
        import('./containers/MenuEngineering')
        .then((module) => {
          cb(null, withRouter(module.default));
        });
      },
    },
    {
      path: `${ routeCodes.MENU_ENGINEERING }${ subRouteCodes.MENU_ENGINEERING.MANAGE_MENU }(/:id)`,
      getComponent(location, cb) {
        import('./containers/ManageMenu')
        .then((module) => {
          cb(null, withRouter(module.default));
        });
      },
    },
    {
      path: `${ routeCodes.MENU_ENGINEERING }${ subRouteCodes.MENU_ENGINEERING.MENU_ANALYSIS }(/:id)`,
      getComponent(location, cb) {
        import('./containers/MenuAnalysis')
        .then((module) => {
          cb(null, withRouter(module.default));
        });
      },
    },
    {
      path: `${ routeCodes.MANAGE_ACCOUNT }(/:workflow)`,
      getComponent(location, cb) {
        import('./containers/ManageAccount')
        .then((module) => {
          cb(null, withRouter(module.default));
        });
      },
    },
    {
      path: routeCodes.RECIPES,
      getComponent(location, cb) {
        import('./containers/Recipes')
        .then((module) => {
          cb(null, withRouter(module.default));
        });
      },
    },
    {
      path: `${ routeCodes.RECIPES }${ subRouteCodes.RECIPES.MANAGE_RECIPE }(/:id)`,
      getComponent(location, cb) {
        import('./containers/ManageRecipe')
        .then((module) => {
          cb(null, withRouter(module.default));
        });
      },
    },
    {
      path: `${ routeCodes.INGREDIENTS }${ subRouteCodes.INGREDIENTS.BATCH_MANAGE_RECIPE }(/:id)`,
      getComponent(location, cb) {
        import('./containers/BatchManageRecipe')
        .then((module) => {
          cb(null, withRouter(module.default));
        });
      },
    },
    {
      path: routeCodes.INGREDIENTS,
      getComponent(location, cb) {
        import('./containers/IngredientRecipes')
        .then((module) => {
          cb(null, withRouter(module.default));
        });
      },
    },
    {
      path: routeCodes.DESIGNS,
      getComponent(location, cb) {
        import('./containers/Designs')
        .then((module) => {
          cb(null, withRouter(module.default));
        });
      },
    },
    {
      path: `${ routeCodes.DESIGNS }${ subRouteCodes.DESIGNS.MANAGE_DESIGN }/:step`,
      getComponent(location, cb) {
        import('./containers/ManageDesign')
        .then((module) => {
          cb(null, withRouter(module.default));
        });
      },
    },
    {
      path: `${ routeCodes.DESIGNS }${ subRouteCodes.DESIGNS.CREATE_FROM_THEME }/:step`,
      getComponent(location, cb) {
        import('./containers/CreateDesignFromTheme')
        .then((module) => {
          cb(null, withRouter(module.default));
        });
      },
    },
    {
      path: `${ routeCodes.DESIGNER }(/:id)`,
      getComponent(location, cb) {
        import('./containers/Designer')
        .then((module) => {
          cb(null, withRouter(module.default));
        });
      },
    },
    {
      path: routeCodes.LOGIN,
      getComponent(location, cb) {
        import('./containers/Login')
        .then((module) => {
          cb(null, withRouter(module.default));
        });
      },
    },
    {
      path: routeCodes.VALIDATE_LEGAL,
      getComponent(location, cb) {
        import('./containers/ValidateLegal')
        .then((module) => {
          cb(null, withRouter(module.default));
        });
      },
    },
    {
      path: routeCodes.LOGIN_FAILED,
      getComponent(location, cb) {
        import('./containers/LoginFailed')
        .then((module) => {
          cb(null, withRouter(module.default));
        });
      },
    },
    {
      path: routeCodes.ABOUT,
      getComponent(location, cb) {
        import('./containers/About')
        .then((module) => {
          cb(null, withRouter(module.default));
        });
      },
    },
    {
      path: routeCodes.PLAYGROUND,
      getComponent(location, cb) {
        import('./containers/Playground')
        .then((module) => {
          cb(null, withRouter(module.default));
        });
      },
    },
    {
      path: '*',
      getComponent(location, cb) {
        import('./containers/NotFound')
        .then((module) => {
          cb(null, withRouter(module.default));
        });
      },
    },
    {
      path: `${routeCodes.MANAGE_ACCOUNT}${subRouteCodes.MANAGE_ACCOUNT.ASSET_TRANSFER}`,
      getComponent(location, cb) {
        import('./containers/AssetTransfer')
          .then((module) => {
            cb(null, withRouter(module.default));
          });
      },
    },
  ],
};

export default () => {
  return (
    <Router history={ browserHistory } onUpdate={ logPageView } routes={ componentRoutes } />
  );
};
